import { Fragment, Component } from "react"
import ResizableRect from "react-resizable-rotatable-draggable"
import PropTypes from "prop-types"

class ResizableContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      width: props.width,
      height: props.height,
      top: props.top,
      left: props.left,
      rotateAngle: props.rotateAngle,
    }

    this.handleResize = (style) => {
      const { onChange } = this.props

      const top = Math.round(style.top)
      const left = Math.round(style.left)
      const width = Math.round(style.width)
      const height = Math.round(style.height)

      onChange({
        top,
        left,
        width,
        height,
      })

      this.setState({
        top,
        left,
        width,
        height,
      })
    }

    this.handleRotate = (rotateAngle) => {
      const { onChange } = this.props
      onChange({ rotateAngle })
      this.setState({ rotateAngle })
    }

    this.handleDrag = (deltaX, deltaY) => this.setState(({ top, left }) => {
      const { onChange } = this.props

      const newTop = top + deltaY
      const newLeft = left + deltaX

      onChange({
        top: newTop,
        left: newLeft,
      })

      return {
        top: newTop,
        left: newLeft,
      }
    })
  }

  render() {
    const {
      width,
      height,
      top,
      left,
      rotateAngle,
    } = this.state

    const { children } = this.props

    const contentStyle = {
      width,
      height,
      top,
      left,
      transform: `rotate(${rotateAngle}deg)`,
      position: "absolute",
    }

    return (
      <Fragment>
        <div style={contentStyle}>
          {children}
        </div>

        <div style={{ zIndex: 5 }}>
          <ResizableRect
            top={top}
            rotatable
            left={left}
            aspectRatio={false}
            minWidth={10}
            width={width}
            minHeight={10}
            height={height}
            onDrag={this.handleDrag}
            onRotate={this.handleRotate}
            onResize={this.handleResize}
            zoomable="nw, ne, se, sw"
            rotateAngle={rotateAngle}
          />
        </div>
      </Fragment>
    )
  }
}

ResizableContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  top: PropTypes.number,
  left: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
  rotateAngle: PropTypes.number,
  onChange: PropTypes.func,
}

ResizableContent.defaultProps = {
  children: <div />,
  top: 100,
  left: 100,
  height: 100,
  width: 100,
  rotateAngle: 0,
  onChange: () => {},
}

export default ResizableContent
